export default "__VITE_ASSET__DRwnhcwy__"